import { render } from "./CommunityTalkUserNickNameProfilePic.vue?vue&type=template&id=753e84b5&ts=true"
import script from "./CommunityTalkUserNickNameProfilePic.vue?vue&type=script&lang=ts&setup=true"
export * from "./CommunityTalkUserNickNameProfilePic.vue?vue&type=script&lang=ts&setup=true"

import "./CommunityTalkUserNickNameProfilePic.vue?vue&type=style&index=0&id=753e84b5&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/communityTalk/CommunityTalkUserNickNameProfilePic.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "753e84b5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('753e84b5', __exports__)) {
    api.reload('753e84b5', __exports__)
  }
  
  module.hot.accept("./CommunityTalkUserNickNameProfilePic.vue?vue&type=template&id=753e84b5&ts=true", () => {
    api.rerender('753e84b5', render)
  })

}


export default __exports__